import { defineStore } from 'pinia'

export const useShowsStore = defineStore('shows', {
    state: () => ({
        activeObject: null,
        hasIncreasedReach: false,
    }),
    actions: {
        setActive(show) {
            this.hasIncreasedReach = false
            this.activeObject = show
        },
        // Every mix play calls this, from anywhere in the app, but only the show
        // page ever sets `activeObject` — so most calls arrive with nothing to
        // count against.
        increaseReach() {
            if (this.hasIncreasedReach || !this.activeObject) return

            this.setActive({ ...this.activeObject, reach: this.activeObject.reach + 1 })
            this.hasIncreasedReach = true
        },
    },
})
